import React, { Fragment, useState, useEffect } from "react";
import ScrollIcon from "../../commons/scrollicon/scrollicon";
import Stuffed from "../../commons/stuffedanimals/stuffed";
import Wooden from "../../commons/woodentoys/wooden";
import "./home.css";
import { Link } from "react-router-dom";
import ProductRowHeader from "../../components/product-row-header/product-row-header";
import SingleProduct from "../../components/single-product/single-product";
import Button from "../../commons/button/button";
import Input from "../../commons/input/input";
import { useDispatch, useSelector } from "react-redux";
import { ProductsAction } from "./../../action/product_action";
import MostViewProducts from "./../../data/most-view-products/most-view-products";
import NewProducts from "./../../data/new-products/new-products";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Home = () => {
  const [newsLetterBtn, setNewsLetterBtn] = useState({
    boxshadow: "",
    background: "#b2bec3",
    cursor: "context-menu",
    tooltip: "ایمیل خود را وارد کنید تا فعال شود",
  });
  const [mailOk, setMailOk] = useState(false);
  const [mailInput, setMailInput] = useState("");
  const dispatch = useDispatch();
  const { products } = useSelector((state) => state.productList);

  useEffect(() => {
    dispatch(ProductsAction);
  }, [dispatch]);

  const newsLetterMailHandler = (e) => {
    let firstSearch = e.target.value.includes("@");
    let secondSearcch = e.target.value.includes(".");
    if (firstSearch && secondSearcch && e.target.value.length > 3) {
      if (e.target.value.slice(-1) !== ".") {
        let prevLetterBtn = { ...newsLetterBtn };
        prevLetterBtn.background = "#a5c926";
        prevLetterBtn.boxshadow = "0px 0px 13px -3px #636e72";
        prevLetterBtn.cursor = "pointer";
        prevLetterBtn.tooltip = "عضویت در خبرنامه عروسکی";
        setNewsLetterBtn(prevLetterBtn);
        setMailInput(e.target.value);
        setMailOk(true);
      }
    } else {
      let defaultNewsLetterBtnStyle = {
        boxshadow: "",
        background: "#b2bec3",
        cursor: "context-menu",
        tooltip: "ایمیل خود را وارد کنید تا فعال شود",
      };
      setMailInput(e.target.value);

      setNewsLetterBtn(defaultNewsLetterBtnStyle);
      setMailOk(false);
    }
  };
  const newsletterSubscribeHandler = () => {
    if (mailOk) {
      toast.success(
        <h6 style={{ textAlign: "right", fontFamily: "Iransans" }}>
          عضویت با موفقیت انجام شد.
        </h6>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setMailInput("");
    }
  };
  return (
    <Fragment>
      <div className="container-fluid home_body">
        <div className="row ">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 home_slider_body">
            <img src="https://s19.picofile.com/file/8439980192/aroosaki_header_edited.jpg" />
          </div>
        </div>
        <div className="row scroll_icon_body">
          <a href="#shop_category" spy={true} smooth={true}>
            {" "}
            <ScrollIcon />
          </a>
        </div>
        <div className="scroll_target" id="shop_category"></div>
        <div className="container">
          <div className="row shop_category">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Stuffed />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Wooden />
            </div>
          </div>
          <div className="product_header_row">
            <ProductRowHeader Title="پربازدید ترین ها" />
          </div>
          <div className="most_view_products">
            {MostViewProducts.map((item) => (
              <SingleProduct
                marginLeft="10px"
                marginRight="10px"
                marginTop="50px"
                width="270px"
                Title={item.title}
                Image={item.image}
                id={item.id}
                key={item.id}
                price={item.price}
              />
            ))}
          </div>

          <div className="product_header_row">
            <ProductRowHeader Title="جدیدترین  محصولات" />
          </div>
          <div className="most_view_products">
            {NewProducts.map((item) => (
              <SingleProduct
                marginLeft="10px"
                marginRight="10px"
                marginTop="50px"
                width="270px"
                Title={item.title}
                Image={item.image}
                id={item.id}
                key={item.id}
                price={item.price}
              />
            ))}
          </div>

          <div className="slogan_body">
            <div className="slogan_title">اسباب بازی ، نه فقط برای بازی !</div>
            <h5 className="slogan_text1"> اینجا سن فقط یه عدده !</h5>
            <h5 className="slogan_text2">
              کودکی کنید و از کودکی کردن خود لذت ببرید
            </h5>
            <i className="uil uil-smile-dizzy slogan_logo"></i>
          </div>
          <div className="row vip_sec  ">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 vip_sec_img">
              <img src="https://s19.picofile.com/file/8440040284/5bb5c77ee73150e2021b0db4_side_image_01_p_1080.jpeg" />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 vip_sec_mail ">
              <h5>اشتراک طلایی عروسکی</h5>
              <div className="vip_sec_line"></div>
              <p className="vip_sec_text">
                عروسکی برای کاربرای دوست داشتنیش یه قابلیت خیلی کاربردی قرار
                داده ! با استفاده از اشتراک ویژه عروسکی ، میتونید از تمامی
                امکانات وبسایت و مراکز حضوری مثل ( خونه بازی ها و مهدکودک ها)
                بصورت کاملا رایگان استفاده کنید !
              </p>
              <div className="vip_sec_button_body">
                <Button
                  boxShadow="0px 0px 13px -3px #636e72"
                  background="#a5c926"
                  color="white"
                  heigh="50px"
                  width="180px"
                  radius="23px"
                  tooltip={"اشتراک هفتگی ، ماهانه و سالانه"}
                  tooltiploc="bottom"
                >
                  دریافت اشتراک ویژه
                </Button>
              </div>
            </div>
          </div>
          <div className="row newsletter_body  ">
            <div
              className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 newsletter_button"
              onClick={newsletterSubscribeHandler}
            >
              <Button
                background={newsLetterBtn.background}
                color="white"
                heigh="50px"
                width="100px"
                radius="23px"
                boxShadow={newsLetterBtn.boxshadow}
                cursor={newsLetterBtn.cursor}
                tooltip={newsLetterBtn.tooltip}
                tooltiploc="bottom"
              >
                اشتراک
              </Button>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 newsletter_input">
              <Input
                type="email"
                change={(e) => newsLetterMailHandler(e)}
                placeHolder="ایمیل خود را وارد کنید"
                width="100%"
                value={mailInput}
              />
            </div>

            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 newsletter_text">
              <div>
                با عضویت در خبرنامه عروسکی ، کد تخفیف 10 هزارتومانی دریافت کنید
                !
              </div>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 newsletter_icon">
              <i class="uil uil-envelope-open"></i>
            </div>
          </div>
          <div className="instagram_posts_body">
            <div className="instagram_posts_id">@Aroosaki</div>
            <h4 className="instagram_posts_title">
              عروسکی را در اینستاگرام دنبال کنید
            </h4>
            <div className="row instagram_posts_gallery">
              <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 posts_gallery_item">
                <img src="https://s19.picofile.com/file/8440044884/1.jpg" />
              </div>
              <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 posts_gallery_item">
                <img src="https://s19.picofile.com/file/8440044900/2.jpg" />
              </div>
              <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 posts_gallery_item">
                <img src="https://s18.picofile.com/file/8440044926/3.jpg" />
              </div>
              <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 posts_gallery_item">
                <img src="https://s19.picofile.com/file/8440044942/4.jpg" />
              </div>
              <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 posts_gallery_item">
                <img src="https://s18.picofile.com/file/8440044976/5.jpg" />
              </div>
              <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 posts_gallery_item">
                <img src="https://s18.picofile.com/file/8440044984/6.jpg" />
              </div>
            </div>
            <div className="instagram_posts_button">
              <a href="https://instagram.com" target="_blank">
                <Button
                  boxShadow="0px 0px 13px -3px #636e72"
                  background="#a5c926"
                  color="white"
                  heigh="40px"
                  width="200px"
                  radius="23px"
                >
                  دیدن سایر پست ها
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Fragment>
  );
};

export default Home;
// test8
